import {Component, Inject} from '@angular/core';
import {PROPERTIES_DATA} from '../../core/user-group-injector-data';
import {McOverlayRef} from '../../../core/models/mc-overlay-ref';
import {BzgHorizontalFlipAnimation, BzgSlideDown} from 'bz-genome-angular';

@Component({
  selector: 'user-groups-properties',
  templateUrl: 'user-groups-properties.component.html',
  styleUrls: ['user-groups-properties.component.scss'],
  animations: [BzgHorizontalFlipAnimation, BzgSlideDown]
})
export class UserGroupsPropertiesComponent {
  public properties: { [key: string]: Array<IUserGroupProperty> };
  public currentCondition: IUserGroupCondition;
  private _onApply: Function;
  private _index: number;
  constructor(
    @Inject(PROPERTIES_DATA)
    private _data: {
      properties: any;
      condition: IUserGroupCondition;
      onApply: Function;
      index: number;
    },
    private _ref: McOverlayRef
  ) {
    this.properties = this._data.properties;
    this.currentCondition = _.cloneDeep(this._data.condition);
    this._onApply = this._data.onApply;
    this._index = this._data.index;
  }

  public setProperty(propertyName: string, propertyValue: IUserGroupProperty) {
    this.currentCondition[propertyName] = propertyValue;
  }

  public close() {
    this._ref.close();
  }

  public clearAll() {
    _.forEach(this.properties, (value: IUserGroupProperty[], key: string) => {
      this.currentCondition[key] = null;
    });
  }

  public apply() {
    this._onApply(this.currentCondition, this._index);
    this._ref.close();
  }
}
